// The sandbox guard's refusal: a full-page block that replaces the whole
// app. Nothing else renders behind it, so no page mounts and no further
// request is sent.
export function BlockingError({ message, reason }: { message: string; reason: string }) {
  const unexpected = reason === "UNEXPECTED";
  return (
    <div className="blocking-error" role="alert">
      <div className="blocking-error-card">
        <div className="blocking-error-kicker">{unexpected ? "Console error" : "Console refused to start"}</div>
        <h1>{unexpected ? "The console could not load" : "This console can only run against the provider MOCK sandbox"}</h1>
        <p>{message}</p>
        <p className="mono text-2xs opacity-70">guard: {reason}</p>
        <p className="text-sm opacity-80">
          Fix the deployment (API base <code>/mock-admin</code> proxied to third-party-mock-service in a sandbox
          namespace) and reload. Nothing beyond the environment probe (if it ran at all) was sent.
        </p>
      </div>
    </div>
  );
}
